"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteTags = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const autocomplete_tags_styles_1 = require("./autocomplete-tags.styles");
const components_1 = require("../../components");
const attributes_1 = require("../../constants/attributes");
const AutocompleteTags = (_a) => {
    var { getChipProps, onDelete, renderTagLabel, options } = _a, props = __rest(_a, ["getChipProps", "onDelete", "renderTagLabel", "options"]);
    const renderTags = (value, getTagProps) => value.map(({ value, label }, index) => {
        var _a;
        const _b = getTagProps({ index }), { key, onDelete: onDeleteDefault } = _b, tagProps = __rest(_b, ["key", "onDelete"]);
        const _c = (_a = getChipProps(value)) !== null && _a !== void 0 ? _a : {}, { accent: $accent } = _c, additionalChipProps = __rest(_c, ["accent"]);
        const formattedLabel = renderTagLabel ? renderTagLabel(value) : label;
        const isUnknown = value === attributes_1.SpecialAttributeValue.Unknown;
        return (react_1.default.createElement(autocomplete_tags_styles_1.StyledChip, Object.assign(Object.assign({ variant: "outlined", key: key, label: (react_1.default.createElement(ui_components_1.ToolTip, { title: formattedLabel }, react_1.default.createElement("span", null, formattedLabel))), onDelete: (event) => {
                onDeleteDefault(event);
                if (onDelete)
                    onDelete(value);
            }, "$accent": $accent, "$isUnknown": isUnknown, deleteIcon: react_1.default.createElement(Close_1.default, null) }, tagProps), additionalChipProps)));
    });
    return (react_1.default.createElement(components_1.AutocompleteMultiSelector, Object.assign(Object.assign({}, props), { options: options, renderTags: renderTags })));
};
exports.AutocompleteTags = AutocompleteTags;
exports.default = exports.AutocompleteTags;
